import {
    Component,
    input,
    ChangeDetectionStrategy,
    ViewEncapsulation,
} from '@angular/core';

/** Item da trilha de navegação (breadcrumb). */
export type BreadcrumbItem = {
    /** Texto exibido no item. */
    label: string;
    /** Destino do link do item. */
    link: string;
};

/**
 * Trilha de navegação (breadcrumbs).
 *
 * Exibe um item inicial "Home" seguido dos itens informados em {@link items}.
 * Estilos encapsulados (`ViewEncapsulation.Emulated`).
 */
@Component({
    selector: 'ai-breadcrumbs',
    imports: [],
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Breadcrumbs {
    /** Itens da trilha, na ordem de exibição (obrigatório). */
    items = input.required<BreadcrumbItem[]>();
}
